import axios, { AxiosResponse } from 'axios';
import {
  CHAT_STATUS_URL,
  EDITOR_SETTINGS_URL,
  INIT_URL,
  UPLOAD_TOKEN_URL,
  REPORT_FIRST_EXPAND_URL,
  PAYMENT_SUMMARY,
  USER_PRESENCE,
} from '../constants/endpoints';
import wix from './wix';

export interface ChatInitResult extends AxiosResponse {
  derivedChatroomId: string;
  authKey: string;
  options: object;
  uid: string;
  messagePath: string;
  presencePath: string;
  visitorId: string;
  visitorInstanceId: string;
  location: string;
  shardId: string;
  timestamp: number;
  coreChatToken: string;
  availability: object;
  isBranded: boolean;
}

export class ServerApi {
  private readonly instance;

  constructor() {
    this.instance = wix.getInstance();
  }

  _fetch(options) {
    options.headers = {
      ...options.headers,
      'X-Wix-Chat-Instance': this.instance,
      Authorization: this.instance,
    };
    return axios(options).then(response => response.data);
  }

  post(url, data?) {
    return this._fetch({
      method: 'post',
      url,
      data,
    });
  }

  setEditorVisibilityOff() {
    return this.setEditorVisibility(false);
  }

  setEditorVisibilityOn() {
    return this.setEditorVisibility(true);
  }

  setEditorVisibility(editorVisibility) {
    return this._fetch({
      method: 'put',
      url: EDITOR_SETTINGS_URL,
      data: {
        editorVisibility,
      },
    });
  }

  init(queryParams = {}): Promise<ChatInitResult> {
    return this._fetch({
      method: 'post',
      url: INIT_URL,
      params: queryParams,
    });
  }

  getUploadToken() {
    return this._fetch({
      method: 'get',
      url: UPLOAD_TOKEN_URL,
    });
  }

  getChatStatus() {
    return this._fetch({
      method: 'get',
      url: CHAT_STATUS_URL,
    });
  }

  getPaymentSummary(orderId: string) {
    return this._fetch({
      method: 'get',
      url: PAYMENT_SUMMARY,
      params: {
        orderId,
      },
    });
  }

  reportFirstExpand(allowInput) {
    return this.post(REPORT_FIRST_EXPAND_URL, {
      allowInput,
    });
  }

  setPresence(userPresence, token, context) {
    return this.post(USER_PRESENCE, {
      userPresence,
      token,
      context,
    });
  }
}

export default new ServerApi();
